<script lang="ts">
export default {
  props: {
    data: {
      default: ''
    },
    tag: {
      default: 'div'
    },
  },
  render(): any {
    return this.parse({ [this.tag]: this.data })
  },
  methods: {
    parse(obj: Record<string, any> | string): any {
      if (typeof obj === 'string') {
        return h('span', obj)
      }

      const entry = Object.entries(obj)[0]
      const tag = entry[0]
      let data = entry[1]
      if (Array.isArray(data)) {
        data = data.map(item => this.parse(item))
      } else if (typeof data === 'object') {
        return this.objectParse({tag, data})
      }

      /** Просто строка */
      if (!tag || tag === '0') {
        return h('span', {innerHTML: data}, [])
      }

      return h(tag, data)
    },
    objectParse({tag, data}: { tag: string, data: any }): any {
      let text = data.text

      if (tag === 'a') {
        if (data?.href?.code === 'document' && data?.href?.hash) {
          data.href = `/article/download/?id=${data.href.hash}`
        }
      }
      if (tag === 'div') {
        const keys = Object.keys(data).filter(k => Number.isInteger(+k))
        text = keys.map(k => this.parse(data[k]))
      }

      return h(tag, {ref: data.id, class: data.class, href: data.href}, text)
    }
  }
}
</script>
